import client from '../services/contentfulService.js';

async function getArticles(limit, skip) {
  try {
    const data = await client.getEntries({
      content_type: 'article',
      order: '-sys.createdAt',
      limit: limit,
      skip: skip,
    });
    return data.items;
  } catch (error) {
    console.error('Error fetching article:', error);
  }
}

async function getArticle(id) {
  try {
    const data = await client.getEntry(id);
    return data;
  } catch (error) {
    console.error('Error fetching article:', error);
  }
}

async function getExternalArticles(limit, skip) {
  try {
    const data = await client.getEntries({
      content_type: 'ExternalArticle',
      order: '-sys.createdAt',
      limit: limit,
      skip: skip,
    });
    return data.items;
  } catch (error) {
    console.error('Error fetching article:', error);
  }
}

async function getAuthor(author) {
  try {
    const data = await client.getEntry(author);
    return data;
  } catch (error) {
    console.error('Error fetching article:', error);
  }
}

export default { getArticles, getArticle, getExternalArticles, getAuthor };
